import {useEffect} from 'react';

declare global {
  interface Window {
    Featurebase?: {
      (...args: unknown[]): void;
      q?: unknown[];
    };
  }
}

const SDK_ID = 'featurebase-sdk';
const SDK_SRC = 'https://do.featurebase.app/js/sdk.js';

export const useFeaturebase = () => {
  useEffect(() => {
    const appId = import.meta.env.VITE_FEATUREBASE_APP_ID;
    if (!appId) return;

    if (typeof window.Featurebase !== 'function') {
      window.Featurebase = function (...args: unknown[]) {
        (window.Featurebase!.q = window.Featurebase!.q || []).push(args);
      };
    }

    if (!document.getElementById(SDK_ID)) {
      const script = document.createElement('script');
      script.id = SDK_ID;
      script.src = SDK_SRC;
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(script, firstScript);
    }

    window.Featurebase('boot', {
      appId,
      theme: 'light',
      language: 'en',
    });
  }, []);
};
